import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { API_URL } from '../config';
import { getPokemonId } from '../utils/pokemonMap';
import './AbilityDetail.css';

function AbilityDetail() {
  const { name } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [ability, setAbility] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAbilityDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/abilities/${name}`);
        if (!response.ok) throw new Error('Ability not found');
        const data = await response.json();

        // Only include Pokemon where we can get their ID
        const pokemonWithIds = data.pokemon
          .map(p => ({
            ...p,
            pokedexId: getPokemonId(p.name)
          }))
          .filter(p => p.pokedexId !== null);

        setAbility({
          name: data.name.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' '),
          effect: data.effect,
          flavorText: data.description,
          pokemon: pokemonWithIds
        });
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchAbilityDetails();
  }, [name]);

  const handleBack = () => {
    if (location.state?.from === 'competitive') {
      navigate('/competitive', { state: { scrollPosition: location.state.scrollPosition } });
    } else {
      navigate(-1);
    }
  };

  if (loading) return <div className="loading-container">Loading ability details...</div>;
  if (error) return <div className="error-container">Error: {error}</div>;
  if (!ability) return <div className="error-container">Ability not found</div>;

  return (
    <div className="ability-detail">
      <button onClick={handleBack} className="back-link">← Back</button>
      <div className="ability-header">
        <h2>{ability.name}</h2>
      </div>
      <div className="ability-content">
        <div className="description-section">
          <h3>Description</h3>
          <p>{ability.flavorText}</p>
          <h3>Effect</h3>
          <p>{ability.effect}</p>
        </div>
        {ability.pokemon && ability.pokemon.length > 0 && (
          <div className="pokemon-section">
            <h3>Pokémon with this Ability</h3>
            <div className="pokemon-grid">
              {ability.pokemon.map((p) => (
                <Link 
                  to={`/pokemon/${p.pokedexId}`}
                  key={p.name} 
                  className="pokemon-card"
                >
                  <div className="pokemon-info">
                    <h4>{p.name.charAt(0).toUpperCase() + p.name.slice(1)}</h4>
                    {p.isHidden && <span className="hidden-ability">Hidden Ability</span>}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AbilityDetail; 